import React, { useEffect, useState } from "react";
import { Header } from "../../../components/SpearParts/Layouts/Header";
import { RentalSearchSection } from "../../../components/Rental/Layout/RentalSearchSection";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NoData from "../../../components/NoData/Index";
import { Footer } from "../../../components/SpearParts/Layouts/Footer";
import Axios from "../../../axios/axios";
import RntMiddle from "../../../components/Rental/Layout/RntMiddle";
import TopNavBar from "../../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../../components/SpearParts/Layouts/TopSearchBar";

export default function RentalCategory() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const initialFilters = location.state?.selectedFilters || {
    rentalType: searchParams.get("rentalType") || "",
    categoryId: searchParams.get("categoryId") || "",
    availabilityStatus: searchParams.get("availabilityStatus") || "",
  };
  const filters = {
    rentalType: searchParams.get("rentalType"),
    categoryId: searchParams.get("categoryId"),
  };

  const [selectedFilters, setSelectedFilters] = useState(initialFilters);
  const [rentals, setRentals] = useState(location.state?.rentals || []);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if (location.state?.selectedFilters) {
      setSelectedFilters(location.state.selectedFilters);
    }
    if (location.state?.rentals) {
      setRentals(location.state.rentals);
    }
  }, [location.state]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.append("page", page);
    params.append("limit", 15);

    Axios.post(`/rental/search?${params.toString()}`)
      .then((res) => {
        setRentals(res.data.data);
        setTotalPages(res.data.pages);
      })
      .catch((err) => console.log("Search error", err));
  }, [location.search, page]);

  // ✅ Helpers
  const getBrandName = (brandId) => brandId?.name || "Unknown Brand";
  const getModelName = (modelId) => modelId?.name || "Unknown Model";
  const getCategoryName = (categoryId) =>
    categoryId?.name || "Unknown Category";
  const getRegionName = (regionId) => regionId?.name || "Unknown Region";

  // Helper
  const toTitleCase = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Part card
  const PartCard = ({ product }) => (
    <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
      <Link to={`/rental/product/single/${product._id}`}>
        <div className="prod-div p-2 d-flex flex-column align-items-center">
          {product?.images?.length > 0 && (
            <img src={product.images[0].url} alt={product.partName} />
          )}
          <h6>{toTitleCase(product.partName)}</h6>
        </div>
      </Link>
    </div>
  );

  // Category card
  const CategoryBoxCard = ({ product }) => {
    const navigate = useNavigate();

    const handleClick = () => {
      if (product.subcategories && product.subcategories.length > 0) {
        // Navigate to Subcategory Page
        const updatedFilters = { ...selectedFilters, categoryId: product._id };

        const query = new URLSearchParams(updatedFilters);

        navigate(`/rental/subcategories?${query.toString()}`, {
          state: {
            selectedFilters: updatedFilters, // <-- now updated properly
            category: product,
            rentals,
          },
        });
      } else {
        // Go to product list directly
        const query = new URLSearchParams(selectedFilters);
        query.set("categoryId", product._id);

        navigate(`/rental/products?${query.toString()}`, {
          state: { selectedFilters },
        });
      }
    };

    return (
      <div
        className="category-item"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex flex-column align-items-center">
          {product?.images?.length > 0 && (
            <img src={product.images[0]} alt={product.name} />
          )}
          <h6>{product.name}</h6>
        </div>
      </div>
    );
  };

  const uniqueCategories = Array.isArray(rentals) ? rentals : [];
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Change Page
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo(0, 0);
    }
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  const beforeImageStyle = {
    content: '""',
    position: "absolute",
    left: 0,
    top: "50px",
    width: "400px",
    height: "100%",
    backgroundImage: "url(/images/rental-before.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left top",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };

  const afterImageStyle = {
    content: '""',
    position: "absolute",
    right: 0,
    bottom: "800px",
    width: "200px",
    height: "90%",
    backgroundImage: "url(/images/rental-after.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right bottom",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };

  return (
    <>
      <div className="New-Rnt-Dashboard" style={sectionStyle}>
        {/* <Header /> */}
        <div className="before-image" style={beforeImageStyle}></div>
        <div className="after-image" style={afterImageStyle}></div>
        <div className="Main-div">
          <TopNavBar />
          <div className="TopSearchBar">
            <TopSearchBar />
          </div>
          <div className="container ">
            <RntMiddle initialFilters={selectedFilters} />

            {/* Desktop Layout */}
            <div className="">
              <div className="col-lg-12">
                <Link to="/" className="back">
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>{" "}
                  Back
                </Link>

                <div className="table-responsive mt-3">
                  <table className="table product-table">
                    <thead>
                      <tr>
                        <th style={{ backgroundColor: "#E9EEF4" }} colSpan={8}>
                          &nbsp;
                        </th>
                        {/* <th style={{ backgroundColor: "#E9EEF4" }}>Type</th>
                      <th style={{ backgroundColor: "#E9EEF4" }}>Brand</th>
                      <th style={{ backgroundColor: "#E9EEF4" }}>Model</th>
                      <th style={{ backgroundColor: "#E9EEF4" }}>Category</th>
                      <th style={{ backgroundColor: "#E9EEF4" }}>Region</th>
                      <th style={{ backgroundColor: "#E9EEF4" }}>Year</th> */}
                        {/* <th style={{ backgroundColor: "#E9EEF4" }}>Price / Day</th> */}
                        {/* <th style={{ backgroundColor: "#E9EEF4" }}></th> */}
                      </tr>
                    </thead>
                  </table>
                </div>
                <div className="category-grid mt-4">
                  {rentals.length === 0 ? (
                    <NoData />
                  ) : filters.categoryId ? (
                    rentals.map((rental, index) => (
                      <PartCard key={index} product={rental} />
                    ))
                  ) : (
                    rentals.map((rental, index) => (
                      <CategoryBoxCard key={index} product={rental} />
                    ))
                  )}
                </div>

                {/* Pagination */}
                {!filters.categoryId && totalPages > 1 && (
                  <div className="pagination-container d-flex justify-content-end align-items-center mt-4">
                    <button
                      className="pagination-btn"
                      disabled={page === 1}
                      onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                    >
                      <i className="fa fa-arrow-left"></i>
                    </button>

                    <span className="mx-3">
                      {page} of {totalPages}
                    </span>

                    <button
                      className="pagination-btn"
                      disabled={page === totalPages}
                      onClick={() =>
                        setPage((prev) => Math.min(prev + 1, totalPages))
                      }
                    >
                      <i className="fa fa-arrow-right"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Mobile Layout */}
            <div className="d-block d-lg-none mt-4">
              <div className="row">
                {rentals?.length > 0 ? (
                  filters.categoryId ? (
                    rentals.map((rental, index) => (
                      <PartCard key={index} product={rental} />
                    ))
                  ) : (
                    rentals.map((rental, index) => (
                      <CategoryBoxCard key={index} product={rental} />
                    ))
                  )
                ) : (
                  <div className="text-center py-4">
                    <NoData />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </>
  );
}
